export default {
    user: 'Conseiller',
    bdc_user: 'Agent BDC',
};
